<div class="visits-popup-header">
  Мои визиты
</div>
<div class="visits-popup-my-panel-wrapper">
  <app-visits-express-panel-my [isPopup]="true"></app-visits-express-panel-my>
</div>
